<style>
.is-invalid  .v-select  .vs__dropdown-toggle{
      border-color: #f46a6a;
}
</style>
<script>
import {
  required,
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'CreateModal',
  props:[
    "list"
  ],
  data() {
    return {
      form: {},
      userList:[],
      belgeler:[],
      submitted: false,
      error:'',
    };
  },
  validations: {
    form: {
      brand: { required },
      model: { required },
      year: { required },
      plaka: { required },
      user_id: { required },
    },
  },
  watch:{
    list(props){
      this.form = {...props}
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      
      this.$v.$touch();
     if (this.$v.$invalid) {
        return;
      } else {
        if(this.form.id)
          this.update();
        else
          this.create();
      }
      this.submitted = false;
    },
    create(){
     
      this.$http.post('/vehicles/store', { ...this.form })
        .then(resp => {
          if(!resp.data.error) this.form = {};

          this.$emit('loadItems');
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    update(){
      this.$http.put('/vehicles/' + this.form.id , this.form)
        .then(resp => {
          this.form = {};

          this.$emit('loadItems');
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    remove(id){
      this.$http.delete('/vehicles/' + id)
        .then(resp => {
          if(resp.data.code !==  100)  return notify.error(resp.data.message)

           this.$emit('loadItems');
           return notify.success(resp.data.message)
         })
        .catch(error => error)
    },
    close(){
      this.$parent.$bvModal.hide('modal-scoped')
    },
    userSearch(search) {
      this.$http.post('/users', { search })
        .then(resp => {
          this.userList = resp.data.data
        })
        .catch(error => error)
    },
     dataURLToBlob(file) {
        return new Promise((resolve,reject)=>{
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          })
    },
    async uploadPhotos(){
        var file = event.target.files[0];
        this.error = ''
        const exist= this.belgeler.filter(e=>{
            return e.fileName == file.name
        })

        if(exist.length > 0) return this.error = 'Aynı Dosya İsmi Eklenemez';

        let base64DataFile = await this.dataURLToBlob(file);
        const belge = {
          "file" : this._base64ToArrayBuffer(base64DataFile.replace('data:image/jpeg;base64,','')),
          "fileName" :file.name
        }
        this.belgeler.push(belge)
    },
    _base64ToArrayBuffer(base64) {
        return Uint8Array.from(atob(base64), c => c.charCodeAt(0))
    },
    removePhoto(index){
      this.belgeler.splice(index, 1)
    }
  },
};
</script>

<template>
  <b-modal 
        id="modal-scoped"
        title="Yeni Teyit Girişi"  
        no-close-on-backdrop 
        hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="file">Belge Ekleme</label>
              <input type="file" class="form-control" @change="uploadPhotos()"/>
                <div
                v-if="error.length > 0"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
            <div class="mb-3">
              <div class="table-responsive">
                <table class="table table-bordered  mb-0">
                  <tbody>
                    <tr v-for="(belge,i) in belgeler" :key="belge.fileName">
                      <td style="width:90%">{{ belge.fileName }}</td>
                      <td>
                        <button class="btn btn-danger btn-sm" @click.prevent="removePhoto(i)"><i class="fa fa-trash"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="description">Arıza Açıklaması</label>
               <textarea 
                  class="form-control" 
                  cols="20" 
                  rows="4"
                  placeholder="Arıza Açıklaması">
                </textarea>
              <div
              v-if="submitted && $v.form.user_id.$error"
              class="invalid-feedback"
              >
              <span v-if="!$v.form.user_id.required"
                  >Bu alanı doldurmak zorunludur.</span
              >
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between">
            <b-button 
              type="button" 
              variant="success" 
              class="ms-1"
              >Olumlu
            </b-button>
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button 
              type="button" 
              variant="danger" 
              class="ms-1"
              >Olumsuz
            </b-button>
          </div>
      </form>
    </b-modal>
</template>